import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getResponseMessage } from '../../../../utils/utils';
import { getRootCategories } from '../../../../crud/categories.crud';
import { ICategoryItem } from '../../categories/interfaces';
import { IAppState } from '../../../../store/rootDuck';
import { useDefineUserRole } from '../../../../hooks';

export const useGetRootsCategories = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const isAuthorized = useSelector((state: IAppState) => state.auth.user != null);
  const { me, loadingMe } = useSelector((store: IAppState) => ({
    me: store.profile.me,
    loadingMe: store.profile.loading,
  }));
  const isBuyer = useDefineUserRole(me, ['ROLE_BUYER', 'ROLE_BUYER_STAFF']);
  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR', 'ROLE_VENDOR_STAFF']);
  const isManager = useDefineUserRole(me, ['ROLE_MANAGER']);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState<ICategoryItem[] | null>([]);
  const [page, setPage] = useState({ page: 1, perPage: 20, total: 0 });

  const fetchRoot = async (data: {
    page?: number;
    per_page?: number;
    parentId?: number;
    text?: string;
    only_active?: number;
    with_products?: number;
  }) => {
    setLoading(true);
    getRootCategories(data)
      .then((res: any) => {
        setCategories(res.data.data);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { page, per_page, total } = res.data;
        setPage({ page, perPage: per_page, total });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetch = async (data: {
    page?: number;
    per_page?: number;
    parentId?: number;
    text?: string;
    only_active?: number;
    with_products?: number;
  }) => {
    if (!isAuthorized) {
      fetchRoot(data);
    } else {
      if (loadingMe) return;
      if (!isBuyer && !isVendor && !isManager && !me?.is_admin) return;
      fetchRoot(data);
    }
  };

  return { fetch, loading, categories, page };
};
